import { render, staticRenderFns } from "./dashboardReportsAccounts.vue?vue&type=template&id=16d61f51"
import script from "./dashboardReportsAccounts.vue?vue&type=script&lang=js"
export * from "./dashboardReportsAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports